import React, {Component} from 'react';
import {API} from "aws-amplify";
import {Modal} from "react-bootstrap";
export default class MergeProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      bsClass: 'modal-header modal-header-info',
      modalTitle: '',
      modalMessage: '',
      authorized: false,
      parentId: ''
    }
  }
  async componentDidMount(){
    // make sure the person we're trying to give credits to isn't yourself!
    // do an api call to check it this is you or not
    try {
      const profile = await API.get("api", "/profile/me");
      if (profile.displayedURL !== this.props.childId
        && profile.userId !== this.props.childId
        && profile.userName === this.props.childName
        && this.props.childProvider === 'Admin') {
        this.setState({
          authorized: true,
          parentId: profile.userId
        });
      }
    }
    catch(e) {
      this.setState({authorized: false});
    }
  }

  claimProfile = async () => {
    try {
      await API.put("api", "/profile/merge", {
        body: {
          parentId: this.state.parentId,
          childId: this.props.childId
        }
      });
      this.setState({
        bsClass: 'modal-header modal-header-success',
        modalTitle: 'Profile Claimed',
        modalMessage: 'You have claimed this profile.',
        showModal: true
      });
    } catch (e) {
      let errorMessage = `There was a problem claiming this profile.`;
      if (e.message) {errorMessage = e.message;}
      if (e.response) {errorMessage = e.response.data.errorMessage;}
      this.setState({
        bsClass: 'modal-header modal-header-danger',
        modalTitle: 'Error',
        modalMessage: errorMessage,
        showModal: true
      });
    }
  };

  modalClose = () => {this.setState({showModal: false});};

  render() {
    return (
      <div>
        {this.state.authorized &&
        <span className="giveCredits" onClick={this.claimProfile}><i className="fa fa-user fa-fw" aria-hidden="true"/> <i>Claim Profile</i></span>}


        <Modal show={this.state.showModal} onHide={this.modalClose}>
          <Modal.Header bsClass={this.state.bsClass} closeButton>
            <i className="fa fa-warning fa-fw" aria-hidden="true"/> {this.state.modalTitle}
          </Modal.Header>
          <Modal.Body>
            {this.state.modalMessage}
          </Modal.Body>
        </Modal>


      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Profile/MergeProfile.js